import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * cn — merge conditional class names and resolve Tailwind conflicts.
 * Standard shadcn/ui helper used by every kit primitive.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
